import TimerfastIcon from '@ordr-as/icons/TimerfastIcon';
import { formatClock, isWarnAge } from '../utils';

type Props = {
  createdUtc: string | undefined;
  nowMs: number;
};

const CardHeadTime = ({ createdUtc, nowMs }: Props) => {
  const clock = formatClock(createdUtc);
  if (!clock) return null;

  const warn = isWarnAge(createdUtc, nowMs);
  return (
    <span
      className={`ml-auto flex items-center gap-1 text-small font-semibold whitespace-nowrap ${
        warn ? 'text-orange-darkest' : 'text-grey-dark'
      }`}
    >
      {warn && <TimerfastIcon width={14} height={14} />}
      {clock}
    </span>
  );
};

export default CardHeadTime;
